import * as tslib_1 from "tslib";
import { AbstractPageComponent } from 'src/app/shared/components/abstract-page/abstract-page.component';
var SearchResultComponent = /** @class */ (function (_super) {
    tslib_1.__extends(SearchResultComponent, _super);
    function SearchResultComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.defaultTitle = 'Search results page';
        return _this;
    }
    return SearchResultComponent;
}(AbstractPageComponent));
export { SearchResultComponent };
